class CustomHeader extends HTMLElement {
  constructor() {
    super();

    this.account = this.querySelector('[data-account]');
    this.accountBtn = this.querySelector('[data-account-toggle]');

    this.drawerWrapper = this.querySelector('[data-drawer-wrapper]');
    this.drawer = this.querySelector('[data-drawer]');
    this.drawerBtn = this.querySelector('[data-drawer-toggle]');
    this.drawerCloseBtn = this.querySelector('[data-drawer-close]');

    this.search = this.querySelector('[data-search]');
    this.searchInput = this.querySelector('[data-search-input]');
    this.searchResults = this.querySelector('[data-search-results]');

    this.searchMobile = this.querySelector('[data-search-mobile]');
    this.searchInputMobile = this.querySelector('[data-search-input-mobile]');
    this.searchResultsMobile = this.querySelector('[data-search-results-mobile]');

    this.priceToggle = this.querySelector('[data-price-toggle]');

    this.navItems = this.querySelectorAll('[data-nav-item]');
    this.megaPanel = this.querySelector('[data-mega-panel]');
    this.middleRow = this.querySelector('.custom-header__row-shell--middle');

    this.mobileMenuScreens = this.querySelectorAll('[data-mobile-screen]');
    this.mobileMenuNextButtons = this.querySelectorAll('[data-mobile-next]');
    this.mobileMenuBackButtons = this.querySelectorAll('[data-mobile-back]');

    this.debounceTimerDesktop = null;
    this.debounceTimerMobile = null;
    this.closeMegaTimer = null;

    this.lastScrollY = window.scrollY;
    this.ticking = false;
  }

connectedCallback() {
  this.bindAccount();
  this.bindDrawer();
  this.bindDrawerTabs();
  this.bindMobileMenu();
  this.bindOutsideClick();
  this.bindEscape();
  this.bindPriceToggle();
  this.bindPredictiveSearch();
  this.bindMegaMenu();
  this.bindStickyReveal();
  this.bindStickySpacer();
}

  closeAll(except = null) {
    if (except !== 'account' && this.account) {
      this.account.classList.remove('is-open');
      if (this.accountBtn) this.accountBtn.setAttribute('aria-expanded', 'false');
    }

    if (except !== 'drawer' && this.drawerWrapper) {
      this.drawerWrapper.classList.remove('is-open');
      if (this.drawerBtn) this.drawerBtn.setAttribute('aria-expanded', 'false');
      this.resetMobileMenu();
    }

    if (except !== 'search' && this.search) {
      this.search.classList.remove('is-open');
      if (this.searchResults) this.searchResults.innerHTML = '';
    }

    if (except !== 'search-mobile' && this.searchMobile) {
      this.searchMobile.classList.remove('is-open');
      if (this.searchResultsMobile) this.searchResultsMobile.innerHTML = '';
    }

    if (except !== 'mega' && this.megaPanel) {
      this.megaPanel.classList.remove('is-open');
      this.megaPanel.innerHTML = '';
      this.navItems.forEach((item) => item.classList.remove('is-active'));
    }
  }

  bindAccount() {
    if (!this.account || !this.accountBtn) return;

    this.accountBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = this.account.classList.contains('is-open');
      this.closeAll();

      if (!isOpen) {
        this.account.classList.add('is-open');
        this.accountBtn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  bindDrawer() {
    if (!this.drawerWrapper || !this.drawerBtn) return;

    this.drawerBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = this.drawerWrapper.classList.contains('is-open');
      this.closeAll();

      if (!isOpen) {
        this.drawerWrapper.classList.add('is-open');
        this.drawerBtn.setAttribute('aria-expanded', 'true');
      }
    });

    if (this.drawerCloseBtn) {
      this.drawerCloseBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeAll();
      });
    }

    if (this.drawer) {
      this.drawer.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
  }

bindStickySpacer() {
  if (!this.classList.contains('is-sticky')) return;

  const setOffset = () => {
    const headerHeight = this.offsetHeight;
    document.documentElement.style.setProperty('--custom-header-offset', `${headerHeight}px`);
    document.body.style.paddingTop = `${headerHeight}px`;
  };

  setOffset();
  window.addEventListener('resize', setOffset);
  window.addEventListener('load', setOffset);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(setOffset);
  }
}

  bindDrawerTabs() {
    const tabs = this.querySelectorAll('[data-drawer-tab]');
    const panels = this.querySelectorAll('[data-drawer-panel]');
    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.target;

        tabs.forEach((btn) => btn.classList.remove('is-active'));
        panels.forEach((panel) => panel.classList.remove('is-active'));

        tab.classList.add('is-active');

        const targetPanel = this.querySelector(`#${target}`);
        if (targetPanel) targetPanel.classList.add('is-active');
      });
    });
  }

  bindMobileMenu() {
    if (!this.mobileMenuScreens.length) return;

    this.mobileMenuNextButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.mobileNext;
        this.showMobileScreen(target);
      });
    });

    this.mobileMenuBackButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.mobileBack;
        this.showMobileScreen(target);
      });
    });
  }

  showMobileScreen(target) {
    this.mobileMenuScreens.forEach((screen) => {
      screen.classList.toggle('is-active', screen.dataset.mobileScreen === target);
    });
  }

  resetMobileMenu() {
    if (!this.mobileMenuScreens.length) return;
    this.showMobileScreen('level-1');
  }

  bindOutsideClick() {
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.closeAll();
      }
    });
  }

  bindEscape() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeAll();
      }
    });
  }

  bindPriceToggle() {
    if (!this.priceToggle) return;

    const buttons = this.priceToggle.querySelectorAll('button');
    const storageKey = 'custom-price-display';
    const saved = window.localStorage.getItem(storageKey);

    if (saved) {
      buttons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.value === saved);
      });
      document.documentElement.setAttribute('data-price-display', saved);
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const value = button.dataset.value;
        buttons.forEach((btn) => btn.classList.remove('is-active'));
        button.classList.add('is-active');
        window.localStorage.setItem(storageKey, value);
        document.documentElement.setAttribute('data-price-display', value);
      });
    });
  }

  bindPredictiveSearch() {
    if (this.search && this.searchInput && this.searchResults) {
      this.searchInput.addEventListener('input', () => {
        window.clearTimeout(this.debounceTimerDesktop);
        const query = this.searchInput.value.trim();

        if (query.length < 2) {
          this.search.classList.remove('is-open');
          this.searchResults.innerHTML = '';
          return;
        }

        this.closeAll('search');

        this.debounceTimerDesktop = window.setTimeout(() => {
          this.fetchPredictiveResults(query, this.search, this.searchResults);
        }, 250);
      });

      this.search.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }

    if (this.searchMobile && this.searchInputMobile && this.searchResultsMobile) {
      this.searchInputMobile.addEventListener('input', () => {
        window.clearTimeout(this.debounceTimerMobile);
        const query = this.searchInputMobile.value.trim();

        if (query.length < 2) {
          this.searchMobile.classList.remove('is-open');
          this.searchResultsMobile.innerHTML = '';
          return;
        }

        this.closeAll('search-mobile');

        this.debounceTimerMobile = window.setTimeout(() => {
          this.fetchPredictiveResults(query, this.searchMobile, this.searchResultsMobile);
        }, 250);
      });

      this.searchMobile.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
  }

  fetchPredictiveResults(query, searchWrapper, resultsContainer) {
    const url =
      `${window.Shopify.routes.root}search/suggest` +
      `?q=${encodeURIComponent(query)}` +
      `&resources[type]=product,collection,page,article` +
      `&resources[limit]=6` +
      `&section_id=predictive-search`;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const results = html.querySelector('#shopify-section-predictive-search');

        if (results) {
          resultsContainer.innerHTML = results.innerHTML;
        } else {
          resultsContainer.innerHTML = '<p>No results found.</p>';
        }

        searchWrapper.classList.add('is-open');
      })
      .catch(() => {
        resultsContainer.innerHTML = '<p>Something went wrong. Please try again.</p>';
        searchWrapper.classList.add('is-open');
      });
  }

  bindMegaMenu() {
    if (!this.navItems.length || !this.megaPanel || !this.middleRow) return;

    this.navItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (window.innerWidth <= 989) return;

        window.clearTimeout(this.closeMegaTimer);

        const template = item.querySelector('[data-mega-template]');
        this.navItems.forEach((navItem) => navItem.classList.remove('is-active'));

        if (!template) {
          this.megaPanel.classList.remove('is-open');
          this.megaPanel.innerHTML = '';
          return;
        }

        this.closeAll('mega');
        item.classList.add('is-active');
        this.megaPanel.innerHTML = template.innerHTML;
        this.megaPanel.classList.add('is-open');
      });
    });

    this.middleRow.addEventListener('mouseleave', () => {
      if (window.innerWidth <= 989) return;

      this.closeMegaTimer = window.setTimeout(() => {
        if (!this.matches(':hover')) {
          this.closeAll();
        }
      }, 120);
    });

    this.megaPanel.addEventListener('mouseenter', () => {
      window.clearTimeout(this.closeMegaTimer);
    });

    this.megaPanel.addEventListener('mouseleave', () => {
      this.closeMegaTimer = window.setTimeout(() => {
        this.closeAll();
      }, 120);
    });
  }

bindStickyReveal() {
  if (!this.classList.contains('is-sticky')) return;

  const onScroll = () => {
    const currentY = window.scrollY;
    const delta = currentY - this.lastScrollY;
    const nearTop = currentY <= 10;

    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        if (nearTop) {
          this.classList.remove('is-hidden');
          this.classList.remove('is-sticky-active');
        } else {
          this.classList.add('is-sticky-active');

          if (delta > 4) {
            this.classList.add('is-hidden');
            this.closeAll();
          } else if (delta < -4) {
            this.classList.remove('is-hidden');
          }
        }

        this.lastScrollY = currentY;
        this.ticking = false;
      });

      this.ticking = true;
    }
  };

  this.classList.remove('is-hidden');
  window.addEventListener('scroll', onScroll, { passive: true });
}
}

if (!customElements.get('custom-header')) {
  customElements.define('custom-header', CustomHeader);
}